

const endpoint_login = "login";


const API_URL_LOGIN =
  (process.env.REACT_APP_API_URL as string) + endpoint_login;



export class LoginService {
  // Método para autenticar usuarios
  static async authenticateUser(mail: string, password: string) {
    const response = await fetch(API_URL_LOGIN, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ mail, password }),
    });

    const data = await response.json();

    if (response.status !== 200) {
      throw new Error(data.message);
    }

    // Verificar que el token sea válido
    if (!data.token) {
      throw new Error("Token vacío recibido del servidor");
    }

    return { token: data.token, role: data.role };
  }

}
